import banksFalterBook from 'assets/images/banksFalter.png';
import banksFalterBookOverview from 'assets/images/booksOverview/banksFalter.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const banksFalter = {
  book: {
    id: 'wenn-banken-wanken',
    format: FLIP_BOOKS,
    title: 'When banks falter',
    subtitle: 'Banking knowledge for home use',
    videos: 'Erwin W. Heri',
    layoutAndProduction: 'Hanspeter Frey',
    scope: { pages: 8, videos: 4 },
    price: 0,
    introductions: ['Introduction banks falter'],
    image: banksFalterBook,
    overviewImg: banksFalterBookOverview,
  },
  bookIds: [18],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([0, 0], [18, 18]),
};

export default banksFalter;
